var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5627 13.4469H2.65659L9.39574 6.7078L8.30185 5.61391L1.5627 12.3531V13.4469ZM12.736 5.57484L9.41528 2.29317L10.5092 1.19928C10.8087 0.899759 11.1767 0.75 11.6132 0.75C12.0492 0.75 12.417 0.899759 12.7165 1.19928L13.8104 2.29317C14.1099 2.59269 14.2662 2.95419 14.2792 3.37768C14.2922 3.80065 14.149 4.1619 13.8494 4.46142L12.736 5.57484ZM11.6031 6.72733L3.32074 15.0097H0V11.6889L8.28232 3.40659L11.6031 6.72733Z",
    fill: "#154365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNotification);
export default __webpack_public_path__ + "static/media/editNotification.817c9c976f5e417c1d46cf85c6d6992a.svg";
export { ForwardRef as ReactComponent };